import * as React from 'react';
import {useCallback} from 'react';

import styles from './MarkupText.less';
import DynamicNode from 'src/js/containers/document/components/DynamicNode';
import {ImmutableMap} from 'src/js/model/immutableMap';
import {Tag as TagModel} from 'src/js/model/tag';

const NAME_TO_CLASS = {
  page: 'dlRenderedPage',
  document: 'dlRenderedDocument',
};

interface OwnProps {
  contextParams?: ImmutableMap;
  node: TagModel;
}

type Props = OwnProps;

export const MarkupText: React.FC<Props> = (props) => {
  const renderByName = useCallback((props) => {
    let rendered: React.ReactElement;
    switch (props.node.rawData.name) {
      case 'document': {
        rendered = (
          <div
            className={`${styles.dlMarkupText} ${
              NAME_TO_CLASS[props.node.rawData.name] || ''
            }`}
            id={props.node.getId()}
            data-start={props.node.getStart()}
            data-end={props.node.getEnd()}
          >
            {props.children}
          </div>
        );
        break;
      }
      default: {
        rendered = (
          <span
            className={styles.dlMarkupText}
            id={props.node.getId()}
            data-start={DynamicNode.getStart(props)}
            data-end={DynamicNode.getEnd(props)}
          >
            {props.children}
          </span>
        );
      }
    }
    return rendered;
  }, []);

  return renderByName(props);
};

MarkupText.displayName = 'MarkupText';
